<template>
  <div class="mx-auto quotes">
    <Feedback v-if="!feedbackGiven" />
    <v-btn
      color="#6dbe45"
      class="btns"
      style="color: #ffffff"
      @click="navigateBack()"
    >
      Back</v-btn
    >
    <br />
    <br />

    <div style="color: white; width: 90%; margin: auto">
      <!-- form for  capturing additional user info foR emailing quote -->
      <h4>Rent to Own Application</h4>
      <div class="user_input_form">
        <!-- Contact Details start-->
        <v-card-title>
          <span class="headline">Contact Information</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <label for="first_name">First name</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="first_name"
                  v-model="first_name"
                />
                <br />
                <strong v-if="first_name_empty" style="color: orange"
                  >First name is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label for="last_name">Last name</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="last_name"
                  v-model="last_name"
                />
                <br />
                <strong v-if="last_name_empty" style="color: orange"
                  >Last name is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label for="phone_number">Phone</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="phone_number"
                  v-model="phone_number"
                  maxlength="14"
                />
                <br />
                <strong v-if="phone_number_empty" style="color: orange"
                  >Phone number is required</strong
                >
                <br />
                <strong v-if="phone_number_invalid" style="color: orange"
                  >Please enter 10 digit phone number</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="7">
                <label for="email">Email</label>
                <br />
                <input
                  class="form custom-width"
                  type="email"
                  id="email"
                  v-model="email"
                />
                <br />
                <strong v-if="email_empty" style="color: orange"
                  >Email is required</strong
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- Contact Details end-->
        <!-- Term start-->
        <v-card-title>
          <span class="headline">Select Term </span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" v-if="amountLoading">
                <v-progress-linear
                  color="#ffffff"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </v-col>
              <v-radio-group v-model="term" row dark v-if="!amountLoading">
                <v-radio
                  v-for="(term, i) in terms"
                  :key="i"
                  :value="term.duration"
                  color="#6dbe45"
                  @click="monthly_rate = term.monthlyPayment"
                >
                  <template v-slot:label>
                    <div style="margin-top: 5px">
                      {{ term.duration }} months
                      <strong> (${{ term.monthlyPayment }} /mo + Tax)</strong>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
              <br />
              <strong v-if="term_empty" style="color: orange"
                >Term is required</strong
              >
            </v-row>
          </v-container>
        </v-card-text>
        <!-- Term end-->
        <!-- References start-->
        <v-card-title>
          <span class="headline">References</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <label
              >Reference 1<strong style="color: red; font-size: 20px"
                >*</strong
              ></label
            >
            <v-row no-gutters>
              <v-col cols="12" sm="6" md="4">
                <label for="reference_name_1">Name</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="reference_name_1"
                  v-model="reference_name_1"
                />
                <br />
                <strong v-if="reference_name_1_empty" style="color: orange"
                  >Name is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label for="reference_relationship_1">Relationship</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="reference_relationship_1"
                  v-model="reference_relationship_1"
                />
                <br />
                <strong
                  v-if="reference_relationship_1_empty"
                  style="color: orange"
                  >Relationship is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label for="reference_phone_1">Phone</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="reference_phone_1"
                  v-model="reference_phone_1"
                  maxlength="14"
                />
                <br />
                <strong v-if="reference_phone_1_empty" style="color: orange"
                  >Phone is required</strong
                >
                <br />
                <strong v-if="reference_phone_1_invalid" style="color: orange"
                  >Please enter 10 digit phone number</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label for="reference_city_1">City (Optional)</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="reference_city_1"
                  v-model="reference_city_1"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label for="reference_state_1">State (Optional)</label>
                <br />
                <select
                  class="dropdown custom-select custom-width"
                  id="reference_state_1"
                  v-model="reference_state_1"
                >
                  <option disabled value>States</option>
                  <option
                    v-for="(state_code, state_name) in shipping_states"
                    v-bind:value="state_name"
                    :key="state_code"
                  >
                    {{ state_name }}
                  </option>
                </select>
              </v-col>
            </v-row>
            <br />
            <label
              >Reference 2<strong style="color: red; font-size: 20px"
                >*</strong
              ></label
            >
            <v-row no-gutters>
              <v-col cols="12" sm="6" md="4">
                <label for="reference_name_2">Name</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="reference_name_2"
                  v-model="reference_name_2"
                />
                <br />
                <strong v-if="reference_name_2_empty" style="color: orange"
                  >Name is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label for="reference_relationship_2">Relationship</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="reference_relationship_2"
                  v-model="reference_relationship_2"
                />
                <br />
                <strong
                  v-if="reference_relationship_2_empty"
                  style="color: orange"
                  >Relationship is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label for="reference_phone_2">Phone</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="reference_phone_2"
                  v-model="reference_phone_2"
                  maxlength="14"
                />
                <br />
                <strong v-if="reference_phone_2_empty" style="color: orange"
                  >Phone is required</strong
                >
                <br />
                <strong v-if="reference_phone_2_invalid" style="color: orange"
                  >Please enter 10 digit phone number</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label for="reference_city_2">City (Optional)</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="reference_city_2"
                  v-model="reference_city_2"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <label for="reference_state_2">State (Optional)</label>
                <br />
                <select
                  class="dropdown custom-select custom-width"
                  id="reference_state_2"
                  v-model="reference_state_2"
                >
                  <option disabled value>States</option>
                  <option
                    v-for="(state_code, state_name) in shipping_states"
                    v-bind:value="state_name"
                    :key="state_code"
                  >
                    {{ state_name }}
                  </option>
                </select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- References end -->
        <!-- Shipping Address-->
        <v-card-title>
          <span class="headline">Shipping Address</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="7">
                <label for="shipping_company">Company (Optional)</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="shipping_company"
                  v-model="shipping_company"
                />
              </v-col>
              <v-col cols="12" sm="6" md="7">
                <label for="shipping_address">Address</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="shipping_address"
                  v-model="shipping_address"
                />
                <br />
                <strong v-if="shipping_address_empty" style="color: orange"
                  >Address is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="5">
                <label for="shipping_apartment">Unit # (optional)</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="shipping_apartment"
                  v-model="shipping_apartment"
                />
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <label for="shipping_city">City</label>
                <br />
                <input
                  class="form custom-width"
                  type="text"
                  id="shipping_city"
                  v-model="shipping_city"
                />
                <br />
                <strong v-if="shipping_city_empty" style="color: orange"
                  >City is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <label for="shipping_country">Country</label>
                <br />
                <select
                  class="dropdown custom-select mr-sm-6"
                  id="shipping_country"
                  v-model="shipping_country"
                >
                  <option disabled value>--------</option>
                  <option value="United States">United States</option>
                </select>
                <br />
                <strong v-if="shipping_country_empty" style="color: orange"
                  >Country is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <label for="shipping_state">State</label>
                <br />
                <select
                  class="dropdown custom-select mr-sm-6"
                  id="shipping_state"
                  v-model="shipping_state"
                >
                  <option disabled value>States</option>
                  <option
                    v-for="(state_code, state_name) in shipping_states"
                    v-bind:value="state_name"
                    :key="state_code"
                  >
                    {{ state_name }}
                  </option>
                </select>
                <br />
                <strong v-if="shipping_state_empty" style="color: orange"
                  >State is required</strong
                >
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <label for="shipping_zipcode"
                  >Zip code
                  <v-tooltip top color="#6dbe45">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="#6dbe45" v-bind="attrs" v-on="on"
                        >info</v-icon
                      >
                    </template>
                    <span style="color: black">{{
                      shippingZipCodeMessage
                    }}</span>
                  </v-tooltip>
                </label>
                <br />
                <input
                  class="form"
                  type="text"
                  id="shipping_zipcode"
                  v-model="shipping_zipcode"
                  :readonly="zipcode != ''"
                />
                <br />
                <strong v-if="shipping_zipcode_empty" style="color: orange"
                  >Zip code is required</strong
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- Shipping Address end-->
      </div>

      <v-spacer></v-spacer>
      <br /><br />
      <small v-if="information_missing" style="color: orange"
        >*Please provide the required information before proceeding</small
      >
      <div class="buttons" v-if="!email_send_acknowledge">
        <v-btn
          color="#6dbe45"
          class="btns"
          style="color: #ffffff"
          @click="navigateBack()"
          >Cancel</v-btn
        >
        <v-btn
          color="#6dbe45"
          class="btns"
          style="color: #ffffff"
          @click="submitApplication()"
          >Submit Application</v-btn
        >
      </div>
      <div style="padding: 10px" v-else>
        <label class="btn btn-outline-success">
          {{ confirmation_text_first }}
          <span>
            <a
              href="https://westerncontainersales.com/contact/"
              target="_blank"
              v-if="confirmation_text_second"
              style="color: orange"
              >contact us</a
            >
            {{ confirmation_text_second }}
          </span>
        </label>
        <br />
        <br />
        <v-btn
          color="white darken-1"
          text
          @click="navigateBack()"
          style="background-color: #6dbe45; font-weight: bold"
          >Go Back</v-btn
        >
      </div>
      <br />
      <br />

      <!-- overlay form for quote ends -->
      <br />
      <br />
      <!-- Loader starts -->
      <v-overlay :value="userdata_sending">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
        <p>Submitting....</p>
      </v-overlay>
      <v-overlay :value="userdata_sent">
        <i
          class="fa fa-check-circle sendAnimation"
          style="font-size: 60px; color: green"
        ></i>
        <p>Submitted.</p>
      </v-overlay>
      <!-- Loader starts -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import * as states_list from "../JS/States";
import axios from "axios";
import Feedback from "./FixedComponents/Feedback.vue";
import * as types from "@/store/types";
import { enforceFormat, formatToPhone } from "../JS/FormatPhoneNumber";

export default {
  name: "Quotes",
  components: {
    Feedback,
  },
  data() {
    return {
      first_name: "",
      first_name_empty: false,
      last_name: "",
      last_name_empty: false,
      phone_number: "",
      phone_number_empty: false,
      phone_number_invalid: false,
      email: "",
      email_empty: false,
      shipping_company: "",
      shipping_address: "",
      shipping_address_empty: false,
      shipping_apartment: "",
      shipping_city: "",
      shipping_city_empty: false,
      shipping_state: "",
      shipping_state_empty: false,
      shipping_country: "United States",
      shipping_country_empty: false,
      shipping_zipcode: "",
      shipping_zipcode_empty: false,
      monthly_rate: null,
      term: null,
      term_empty: false,
      reference_name_1: "",
      reference_name_1_empty: false,
      reference_name_2: "",
      reference_name_2_empty: false,
      reference_relationship_1: "",
      reference_relationship_1_empty: false,
      reference_relationship_2: "",
      reference_relationship_2_empty: false,
      reference_phone_1: "",
      reference_phone_1_empty: false,
      reference_phone_1_invalid: false,
      reference_phone_2: "",
      reference_phone_2_empty: false,
      reference_phone_2_invalid: false,
      reference_city_1: "",
      reference_city_2: "",
      reference_state_1: "",
      reference_state_2: "",
      information_missing: false,
      userdata_sending: false,
      userdata_sent: false,
      email_send_acknowledge: false,
      confirmation_text_first: "",
      confirmation_text_second: "",
      shipping_states: [],
      terms: [],
      buildingDetails: {},
      amountLoading: false,
      lineItems: [],
      totalPrice: 0.0,
      totalDeliveryFee: 0.0,
      total_quantity: 0,
      referencePanels: [0, 1],
      phoneNumberElement: null,
      referencePhoneElement_1: null,
      referencePhoneElement_x2: null,
      shippingZipCodeMessage:
        "If you would like to submit application for a different delivery address, please start over and enter the delivery address zip code",
      termHeaderMessage: "Tax will calculated at the checkout",
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    this.shipping_zipcode = this.zipcode;
    if (
      this.CART.length === 0 ||
      //!this.terms_conditions ||
      this.COUNTRY_CODE === "CA"
    )
      this.$router.push("/purchase/container/cart");
    this.initializePricing();
    this.shipping_states = states_list.US_States;
    this.calculateAmountAPI();
    //Add Event Listener to auto format phone number
    this.phoneNumberElement = document.getElementById("phone_number");
    this.referencePhoneElement_1 = document.getElementById("reference_phone_1");
    this.referencePhoneElement_2 = document.getElementById("reference_phone_2");

    this.phoneNumberElement.addEventListener("keyup", formatToPhone);
    this.phoneNumberElement.addEventListener("keydown", enforceFormat);
    this.referencePhoneElement_1.addEventListener("keydown", enforceFormat);
    this.referencePhoneElement_1.addEventListener("keyup", formatToPhone);
    this.referencePhoneElement_2.addEventListener("keydown", enforceFormat);
    this.referencePhoneElement_2.addEventListener("keyup", formatToPhone);
  },
  beforeDestroy() {
    //Remove Event Listener which was added on phone number
    this.phoneNumberElement.removeEventListener("keydown", enforceFormat);
    this.phoneNumberElement.removeEventListener("keyup", formatToPhone);
    this.referencePhoneElement_1.removeEventListener("keydown", enforceFormat);
    this.referencePhoneElement_1.removeEventListener("keyup", formatToPhone);
    this.referencePhoneElement_2.removeEventListener("keydown", enforceFormat);
    this.referencePhoneElement_2.removeEventListener("keyup", formatToPhone);
  },
  computed: {
    ...mapState(["feedbackGiven", "zipcode"]),
    ...mapGetters({
      COUNTRY_CODE: types.COUNTRYCODE,
      CART: types.CART_LIST,
      terms_conditions: types.TERMSCHECKBOX,
      delivery: types.DELIVERY,
    }),
  },
  methods: {
    ...mapActions({
      calculateRTOAmount: types.ACTIONS_CALCULATE_RTOAMOUNT,
      resetCart: types.ACTIONS_UPDATE_RESETCART,
    }),
    navigateBack() {
      if (this.$route.query.redirect) {
        this.resetCart();
        this.$router.push(this.$route.query.redirect);
        return;
      }
      this.$router.push("/purchase/container/cart");
    },
    initializePricing() {
      const cart = this.CART;
      var cscSurveyId = "",
        cscQuantity = 0,
        totalShippingPrice = 0,
        totalContainerPrice = 0,
        totalCSCSurveyPrice = 0;

      for (var index in cart) {
        this.createBuildingDetails(cart[index]);
        var QUANTITY = cart[index]["quantity"];
        this.lineItems.push({
          variantId: cart[index]["id"],
          Quantity: QUANTITY,
        });

        this.total_quantity += QUANTITY;
        totalShippingPrice += cart[index]["haulingPrice"] * QUANTITY;
        totalContainerPrice += cart[index]["price"] * QUANTITY;
        //Check for CSC survey attribute in each line item.
        if ("CSCSurvey" in cart[index]) {
          cscQuantity += QUANTITY;
          cscSurveyId = cart[index]["CSCSurvey"]["id"];
          totalCSCSurveyPrice += cart[index]["CSCSurvey"]["price"] * QUANTITY;
        }
      }
      //Add csc survey if the csc quantity is greater than zero.
      if (cscQuantity > 0) {
        this.lineItems.push({
          variantId: cscSurveyId,
          Quantity: cscQuantity,
        });
      }
      this.totalDeliveryFee = totalShippingPrice;
      this.totalPrice = totalShippingPrice + totalCSCSurveyPrice;
      if (this.total_quantity > 1)
        this.totalPrice += 0.95 * totalContainerPrice;
      else this.totalPrice += totalContainerPrice;
    },
    createBuildingDetails(item) {      
      let date = new Date();
      date.setDate(date.getDate() + 30);
      let dimensions = item.title.match(/\d+/g);
      let containerType = item.title.split(" ").slice(1).join(" ");
      let buildingType = "";

      switch(item.condition){
        case "One Trip":
          buildingType = "one_trip"
          break;
        case "WWT":
          buildingType = "wind_and_water_tight"
          break;
        case "CWO":
          buildingType = "cargo_worthy"
          break;
      }

      this.buildingDetails = {
        building: buildingType,
        estimated_delivery_date: this.$options.filters.formatDate(date),
        brand: "Western",
        serial_number: item.sku,
        size_width: Number(dimensions[0]),
        size_length: Number(dimensions[1]),
        model: `${containerType} - ${item.condition}`,
      };      
    },
    submitApplication() {
      this.makeDefault();
      if (!this.validateUserInputs()) return;

      this.userdata_sending = true;
      const payload = this.getPayload();
      this.sendDataAWS(payload);
    },
    getPayload() {
      return {
        Email: this.email,
        LineItems: this.lineItems,
        First_Name: this.first_name,
        Last_Name: this.last_name,
        Phone: parseInt(this.phone_number.replace(/\D/g, "")),
        Shipping_Address: {
          first_name: this.first_name,
          last_name: this.last_name,
          company: this.shipping_company,
          address1: this.shipping_address,
          address2: this.shipping_apartment || null,
          city: this.shipping_city,
          state: this.shipping_state,
          state_code: states_list.US_States[this.shipping_state],
          zipcode: this.shipping_zipcode,
          country: this.shipping_country,
          country_code: "US",
          phone: parseInt(this.phone_number.replace(/\D/g, "")),
        },
        building_details: this.buildingDetails,
        Shipping_Price: this.totalDeliveryFee,
        Shopify_CountryCode: this.COUNTRY_CODE,
        Total_Quantity: this.total_quantity,
        Cash_Price: this.totalPrice,
        Term: this.term,
        Monthly_Rate: this.monthly_rate,
        References: [
          {
            name: this.reference_name_1,
            phone: parseInt(this.reference_phone_1.replace(/\D/g, "")),
            relationship: this.reference_relationship_1,
            city: this.reference_city_1,
            state: this.reference_state_1
              ? states_list.US_States[this.reference_state_1]
              : "",
          },
          {
            name: this.reference_name_2,
            phone: parseInt(this.reference_phone_2.replace(/\D/g, "")),
            relationship: this.reference_relationship_2,
            city: this.reference_city_2,
            state: this.reference_state_2
              ? states_list.US_States[this.reference_state_2]
              : "",
          },
        ],
      };
    },
    validateUserInputs() {
      let phoneNumber = this.phone_number.replace(/\D/g, "");
      let referencePhone_1 = this.reference_phone_1.replace(/\D/g, "");
      let referencePhone_2 = this.reference_phone_2.replace(/\D/g, "");

      let validation =
        this.first_name &&
        this.last_name &&
        this.phone_number &&
        phoneNumber.length === 10 &&
        this.email &&
        this.shipping_address &&
        this.shipping_city &&
        this.shipping_state &&
        this.shipping_country &&
        this.shipping_zipcode &&
        this.term &&
        this.reference_name_1 &&
        this.reference_name_2 &&
        this.reference_relationship_1 &&
        this.reference_relationship_2 &&
        this.reference_phone_1 &&
        referencePhone_1.length === 10 &&
        this.reference_phone_2 &&
        referencePhone_2.length === 10;

      if (validation) return true;

      this.information_missing = true;
      if (this.first_name === "") this.first_name_empty = true;
      if (this.last_name === "") this.last_name_empty = true;
      if (this.phone_number === "") this.phone_number_empty = true;
      else if (phoneNumber.length != 10) this.phone_number_invalid = true;
      if (this.email === "") this.email_empty = true;
      if (this.shipping_address === "") this.shipping_address_empty = true;
      if (this.shipping_city === "") this.shipping_city_empty = true;
      if (this.shipping_country === "") this.shipping_country_empty = true;
      if (this.shipping_state === "") this.shipping_state_empty = true;
      if (this.shipping_zipcode === "") this.shipping_zipcode_empty = true;
      if (!this.term) this.term_empty = true;
      if (this.reference_name_1 === "") this.reference_name_1_empty = true;
      if (this.reference_name_2 === "") this.reference_name_2_empty = true;
      if (this.reference_relationship_1 === "")
        this.reference_relationship_1_empty = true;
      if (this.reference_relationship_2 === "")
        this.reference_relationship_2_empty = true;
      if (this.reference_phone_1 === "") this.reference_phone_1_empty = true;
      else if (referencePhone_1.length != 10)
        this.reference_phone_1_invalid = true;
      if (this.reference_phone_2 === "") this.reference_phone_2_empty = true;
      else if (referencePhone_2.length != 10)
        this.reference_phone_2_invalid = true;

      return false;
    },
    makeDefault() {
      this.information_missing = false;
      this.first_name_empty = false;
      this.last_name_empty = false;
      this.phone_number_empty = false;
      this.phone_number_invalid = false;
      this.email_empty = false;
      this.shipping_address_empty = false;
      this.shipping_city_empty = false;
      this.shipping_country_empty = false;
      this.shipping_state_empty = false;
      this.shipping_zipcode_empty = false;
      this.term_empty = false;
      this.reference_name_1_empty = false;
      this.reference_name_2_empty = false;
      this.reference_relationship_1_empty = false;
      this.reference_relationship_2_empty = false;
      this.reference_phone_1_empty = false;
      this.reference_phone_1_invalid = false;
      this.reference_phone_2_empty = false;
      this.reference_phone_2_invalid = false;
      this.confirmation_text_first = "";
      this.confirmation_text_second = "";
    },
    sendDataAWS(payload) {
      const url =
        "https://8bikxb8159.execute-api.us-west-2.amazonaws.com/prod/rent-to-own";
      var headers_list = {
        "X-API-Key": "pVNXIov86ZkPVyDo8v787bgNIlh40Ve1C4Cdxg2a",
        "content-type": "application/json",
      };
      axios
        .post(url, payload, { headers: headers_list })
        .then((response) => {
          this.displayMessage(response);
        })
        .catch((err) => {
          console.log(err);
          this.userdata_sending = false;
          this.email_send_acknowledge = true;
          this.confirmation_text_first =
            "Oops, something weird happened. Please ";
          this.confirmation_text_second = " for further assistance.";
        });
    },
    calculateAmountAPI() {
      this.amountLoading = true;
      this.calculateRTOAmount(this.totalPrice)
        .then((response) => {
          this.terms = response.data.Details;
          this.amountLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.amountLoading = false;
        });
    },
    displayMessage(response) {
      const response_data = response.data;
      this.userdata_sending = false;
      const result = response_data.Result;
      if (result != "Success") {
        this.email_send_acknowledge = true;
        this.confirmation_text_first =
          "Oops, something weird happened. Please ";
        this.confirmation_text_second = " for further assistance.";
      } else {
        this.userdata_sent = true;
        setTimeout(() => {
          this.userdata_sent = false;
          this.email_send_acknowledge = true;
          this.confirmation_text_first =
            "Thank you for submitting your applicaiton, someone from My Container Rental will be in touch within 1 business day.";
          this.confirmation_text_second = "";
        }, 2000);
      }
    },
  },
};
</script>

<style scoped>
.btns {
  height: 50px;
  color: #00587d;
  text-decoration: none;
  text-transform: unset !important;
  border-radius: 20px;
  font-weight: 900;
  box-shadow: 1px 1px 1px 1px #ffffff;
  background-image: linear-gradient(to bottom, #6dbe45 0%, #3b701e 100%);
}

.custom-width {
  width: 70%;
}

label {
  color: #ffffff;
  padding-left: 10px;
}
.user_input_form {
  text-align: left;
}

.buttons button[class*="btn"] {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.form {
  border-radius: 10px;
  border: 2px solid green;
  padding: 10px;
  background-color: rgb(255, 255, 255);
  text-align: center;
  font-size: 15px;
  color: black;
  font-weight: 100;
}

.dropdown {
  border-radius: 10px;
  border: 2px solid green;
  background-color: rgb(255, 255, 255);
  text-align: center;
  color: black;
  font-weight: 100;
}
.sendAnimation {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.5s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media only screen and (max-width: 800px) {
  .custom-width,
  .form {
    width: 100%;
  }
}
</style>
